import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class HideAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: Callback) {
        item.alpha = 0;
        item.paperCutVisible(false);
        this.onComplete();
        cb();
    }
}
